import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  namePreview: {
    wordBreak: 'break-word'
  }
})

export default useStyles
